import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import jwt_decode from 'jwt-decode';

// True when a non-expired JWT is present.
// Note: `exp` is SECONDS since epoch; Date.now() is MILLISECONDS — the ×1000
// was missing before (so the comparison was always false). jwt_decode is also
// guarded so a malformed token redirects instead of throwing.
function isAuthenticated() {
  try {
    const token = localStorage.getItem('token');
    if (!token) return false;
    const decoded = jwt_decode(token);
    if (decoded && typeof decoded.exp === 'number') {
      return decoded.exp * 1000 > Date.now();
    }
    return true; // token present, no exp claim — treat as valid
  } catch (_) {
    return false; // malformed token
  }
}

// Supports BOTH usage forms:
//   <PrivateRoute path="..."><Page/></PrivateRoute>   (children — what App.js uses)
//   <PrivateRoute path="..." component={Page} />        (legacy)
// Previously only the `component=` form was handled, and since App.js passes
// children, react-router v5 ignored the `render` prop entirely — so the auth
// gate never ran. Using `render` (and not also passing `children` to Route)
// makes the gate effective in both forms.
const PrivateRoute = ({ children, component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated()
        ? (children || (Component ? <Component {...props} {...rest} /> : null))
        : <Redirect to={{ pathname: '/sign-in', state: { from: props.location } }} />
    }
  />
);

export default PrivateRoute;
